/**
 * Checks if a value is empty.
 * @param value - The value to check.
 * @returns True if the value is empty, otherwise false.
 */
const isEmpty = (value: unknown): boolean => {
  if (value == null) {
    // Check for null or undefined
    return true;
  }

  if (typeof value === 'string' || Array.isArray(value)) {
    // Check for empty string or array
    return value.length === 0;
  }

  if (typeof value === 'object') {
    // Check for empty object
    return Object.keys(value).length === 0;
  }

  return false;
};

export default isEmpty;
